import { QueryClient } from '@tanstack/react-query'

/**
 * App-wide React Query client. Kept in a module singleton so auth/session code
 * can clear cached server data on login, logout, and forced logout (token expiry).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

/**
 * Drops all cached query/mutation data so the next fetch uses the current session
 * (new bearer token, new user). Equivalent intent to Apollo `resetStore()`.
 */
export function clearSessionQueries(): void {
  queryClient.clear()
}

if (typeof window !== 'undefined') {
  window.addEventListener('auth:logout', () => {
    queryClient.clear()
  })
}
